import { createContext } from 'react'

const ContextLoader = createContext()

export { ContextLoader }